// @ts-expect-error: Could not find a declaration file for module
import { createAction } from 'flux-actions';
import * as ActionTypes from '../../constants/VisitorActionTypes';
export const networkOffline = createAction(ActionTypes.NETWORK_OFFLINE);